import React from "react";

export const Header = (props) => {


  const isFeatureIsInViewFront = props.objectInViewFront?.feature
  return (
    <>
      <header id="header" className={`${'sticky top-0'}`}>
        <div className={`intro skill-landing-img`}>
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="col-md-8 col-md-offset-2 intro-text">
                  <h1>
                    {props.data?.title}
                    <span></span>
                  </h1>
                  <p>{props.data ? props.data.paragraph : "Loading"}</p>
                  <a
                    href="#features"
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    Learn More
                  </a>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>

  );
};
